<template>
    <layout>
        <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button></span>
        <div slot="content">
            <el-form>
                <el-form-item label="실청구금액">
                    <el-input type="number" v-model="form.billAmt"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-folder-checked" @click="saveRealAmt">저장</el-button>
                </el-form-item>
            </el-form>
        </div>
    </layout>
</template>

<script>
/**
 * * components
 */
 import Layout from '@/components/Slot/ModalSlot.vue';
/**
 * lodash
 */
 import _ from 'lodash';

export default {
    components: {Layout},
    props: {
        data: {
            Type: Object,
            default: {
                asId: ''
            }
        }
    },
    data() {
        return {
            title: '실청구금액변경',
            form: {
                billAmt: 0,
                asId: ''
            }
        }
    },
    watch: {
        'data': {
            deep: true,
            immediate: true,
            handler(value){
                this.form = value;
            }
        }
    },
    methods: {
        saveRealAmt(){
            console.log('this.form.billAmt: ', this.form.billAmt)
            if(this.form.billAmt === undefined){
                this.$swal({
                    type: 'warning',
                    text: '실청구금액을 입력하시기 바랍니다.'})

                return false
            }

            const vSaveform = {
                asId: this.form.asId,
                asRepairFeeAmtReal: this.form.billAmt
            }
            this.$swal({
                    type: 'warning',
                    text: '실청구금액을 변경하시겠습니까?',
                    showCancelButton: true,
                    confirmButtonText: '예',
                    cancelButtonText: '아니오',
                }).then((result) => {
                    if (result.value) {
                        let vResultOK = 'OK'
                        this.$store.commit('loading')
                        this.$http.put("/api/asMng/call/saveRepairFeeRealUpt", vSaveform)
                            .then(response => {
                                this.$swal({ type: 'success', text: '실청구금액이 변경되었습니다.' });
                                
                            }).catch((e) => {
                                vResultOK = 'FAIL'
                                console.error(e);
                                this.$swal({ type: 'success', text: '실청구금액이 변경에 실패했습니다.' })
                            })
                            .finally(() => {
                                this.$store.commit('finish')

                                this.$emit('close', vResultOK)
                                this.$parent.close()
                            });
                    }
                });
        }
    }
}
</script>